export default __webpack_public_path__ + "static/media/icon-squat.9b12d2e9.svg";